import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

declare const $: any;

@Component({
  selector: 'app-toilet',
  templateUrl: './toilet.component.html',
  styleUrls: ['./toilet.component.scss']
})
export class ToiletComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  isEditMode: boolean=false;
  toilet_id: string ='';
  toiletForm: any = {}
  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe : DatePipe
    ) {this.isEditMode = false;}

    isLoading=false;
    roleId=0;
  ngOnInit(){
    this.roleId = Number(localStorage.getItem('roleId'));
    this.ViewAllDevices();
    this.ViewZone("");
    this.ViewToilets();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Toilet Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Toilet Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Toilet Master' 
        }
      ]
    };

  }

  normalizeTimestamp(timestamp: number): number {
    const length = timestamp.toString().length;

    if (length === 10) {
      // Convert seconds → milliseconds
      return timestamp * 1000;
    } else if (length === 13) {
      // Already in milliseconds
      return timestamp;
    } else {
      throw new Error("Invalid timestamp format");
    }
  }

  ClearForm(){
    this.isEditMode=false;
    this.toiletForm={};
  }
  filterZoneList: any = [];
  filterWardList: any = [];
  filterZoneIds: any[] = [];
  filterWardIds: any[] = [];
  zoneRowdata: any;
  zone_details: any = [];
  zoneDataArr: any = [];

  async ViewZone(zone_id){
    try {
      const zone_data = {
        'zone_no':zone_id,
      };
      this.zone_details=[];
      console.log(zone_data);
      const data: any = await this.request.post('/master/view_zone_master',zone_data);
      console.log(data);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].zone_id,
              zone_name:dataObj[objKey1].zone_no+" ("+dataObj[objKey1].zone_name+")"
            };
            // console.log(arr);
            this.zone_details.push(arr);
          } 
        }				
      }
      this.zoneDataArr = this.zone_details;
      this.filterZoneList = this.zoneDataArr;
    } catch (error) {}
  }

  async onFilterZoneChange(event: any) {
    this.filterWardList = [];
    this.filterWardIds = [];
    if (!this.filterZoneIds || this.filterZoneIds.length === 0) {
      this.applyFilter();
      return;
    }
    for (let zoneId of this.filterZoneIds) {
      await this.LoadWardsForFilter(zoneId);
    }
    this.applyFilter();
  }

  async LoadWardsForFilter(zone_id: any) {
    try {
      const data: any = await this.request.post('/master/view_ward_master_by_zone', { zone_no: zone_id });
      if (data && data.result) {
        for (let ward of data.result) {
          const exists = this.filterWardList.some((x: any) => x.id === ward.ward_id);
          if (!exists) {
            this.filterWardList.push({
              id: ward.ward_id,
              ward_name: ward.ward_no + " (" + ward.ward_name + ")"
            });
          }
        }
      }
      this.filterWardList = [...this.filterWardList];
    } catch (error) {
      console.error(error);
    }
  }

  onFilterWardChange(event: any) {
    this.applyFilter();
  }

  applyFilter() {
    let filtered = [...this.toiletDetails];
    if (this.filterZoneIds && this.filterZoneIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterZoneIds.includes(item.zone_id) || 
        this.filterZoneIds.includes(Number(item.zone_id)) || 
        this.filterZoneIds.includes(String(item.zone_id))
      );
    }
    if (this.filterWardIds && this.filterWardIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterWardIds.includes(item.ward_id) || 
        this.filterWardIds.includes(Number(item.ward_id)) || 
        this.filterWardIds.includes(String(item.ward_id))
      );
    }
    this.toiletRowdata = filtered;
    this.rerenderTable();
  }

  resetFilter() {
    this.filterZoneIds = [];
    this.filterWardIds = [];
    this.filterWardList = [];
    this.toiletRowdata = [...this.toiletDetails];
    this.rerenderTable();
  }

  rerenderTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }

  zoneId=0;
  GetZoneName(zone_id){
    // alert(zone_id);
    this.zoneId = zone_id;
    this.ViewWardByZone(zone_id);
  }

  ward_details=[];
  wardRowdata;
  wardDataArr;
  async ViewWardByZone(zone_id){
    try {
      const zone_data = {
        'zone_no':zone_id,
      };
      this.ward_details=[];
      const data: any = await this.request.post('/master/view_ward_master_by_zone',zone_data);
      // console.log(data);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].ward_id,
              ward_name:dataObj[objKey1].ward_no+" ("+dataObj[objKey1].ward_name+")"
            };
            // console.log(arr);
            this.ward_details.push(arr);
          } 
        }				
      }
      this.wardDataArr = this.ward_details;
    } catch (error) {}
  }

  device_details=[];
  deviceDataArr:any;
  async ViewAllDevices(){
    try {
      let arr = {
        id:"0",
        device_id:"0"
      };
      // console.log(arr);
      this.device_details.push(arr);
      const device = {
        'device_id': "",
      };
      const data: any = await this.request.post('/master/view_device',device);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            arr = {
              id:dataObj[objKey1].device_id,
              device_id:dataObj[objKey1].device_id
            };
            // console.log(arr);
            this.device_details.push(arr);
          } 
        }				
      }
      this.deviceDataArr = this.device_details;
    } catch (error) {}
  }

  toiletViewDetails;
  async EditToilet(tData){
    try {
      this.isEditMode=true;
      this.toiletForm = tData;
      this.toiletForm = {
        ...tData,
        zone_id: String(tData.zone_id),
        ward_id: String(tData.ward_id)
      };
      this.ViewWardByZone(this.toiletForm.zone_id);
      $("#toilet_id").val(this.toiletForm.toilet_id);
      console.log(this.toiletForm);
    } catch (error) {}
  }

  async DeleteToilet(toilet_id) {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
      });
      if (confirm.value) {
      const toilet = {
        'toilet_id': toilet_id
      };
      const allow: any = await this.request.post('/master/delete_toilet/',toilet);
      if (allow) {
        // Successfully Deleted
        Swal.fire(
        'Deleted!',
        'Toilet Information has been deleted.',
        'success'
        );
        // Reload DataTable
        // this.ViewDrivers();
        window.location.reload();
        // this.ngOnInit();
      } else {
        Swal.fire(
          'Error!'
        );
      }
    }
  }

  toiletRowdata:any;
  toiletDetails=[];
  async ViewToilets(){
    try {
      this.isLoading=true;
      // alert("here");
      const device = {
        'toilet_id': 0,
      };
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_toilet',device);
      this.toiletDetails=[];
      //alert(data);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            dataObj[objKey1].device_assignment_date = this.normalizeTimestamp(Number(dataObj[objKey1].device_assignment_date));
            this.toiletDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.toiletRowdata = this.toiletDetails;
      // console.log(this.toiletRowdata);
      this.isLoading=false;
    } catch (error) {}
  }

  deviceId;
  GetDeviceName(deviceId){
    this.deviceId = deviceId;
  }

  onSubmit(): void {
    if (this.isEditMode) {
      this.UpdateToilet();
    } else {
      this.SaveToilet();
    }
  }

  isViewMode=false;
  isUpdatedRecord;
  message;
  async SaveToilet(){
    try {
      const toilet_data = {
        'toilet_name': this.toiletForm.toilet_name,
        'toilet_no': this.toiletForm.toilet_no,
        'address':this.toiletForm.address,
        'landmark':this.toiletForm.landmark,
        'lattitude':Number(this.toiletForm.lattitude),
        'longitude':Number(this.toiletForm.longitude),
        'device_id':this.toiletForm.device_id,
        'toilet_type':this.toiletForm.toilet_type,
        'zone_id':Number(this.toiletForm.zone_id),
        'ward_id':Number(this.toiletForm.ward_id),
        'google_toilet_id':this.toiletForm.google_toilet_id,
        'supervisor_name':this.toiletForm.supervisor_name,
        'supervisor_mobile':this.toiletForm.supervisor_mobile,
      };
      // console.log(toilet_data);
      const save: any = await this.request.post('/master/add_toilet',toilet_data);
      // console.log(save);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }
  }

  async UpdateToilet(){
      try {
      const toilet_data = {
        'toilet_id': Number($("#toilet_id").val()),
        'toilet_name': this.toiletForm.toilet_name,
        'toilet_no': this.toiletForm.toilet_no,
        'address':this.toiletForm.address,
        'landmark':this.toiletForm.landmark,
        'lattitude':this.toiletForm.lattitude,
        'longitude':this.toiletForm.longitude,
        'device_id':this.toiletForm.device_id,
        'toilet_type':this.toiletForm.toilet_type,
        'zone_id':this.toiletForm.zone_id,
        'ward_id':this.toiletForm.ward_id,
        'google_toilet_id':this.toiletForm.google_toilet_id,
        'supervisor_name':this.toiletForm.supervisor_name,
        'supervisor_mobile':this.toiletForm.supervisor_mobile,
      };
      // console.log(toilet_data);
      const save: any = await this.request.post('/master/update_toilet',toilet_data);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Updated',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }
  }

  async sendSmsNotification(deviceId:any) {
    try{
      // alert(deviceId);
      const confirm = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, send it!'
      });
      if (confirm.value) {
        const payload = {
          deviceId: deviceId,
          smsType: "feedback"
        };
        console.log(payload);
        const allow: any = await this.request.post('/dashboard/update_live_device_status',payload);
        if (allow) {
          Swal.fire(
          'Success!',
          'SMS has been send successfully.',
          'success'
          );
          // Reload DataTable
          // this.ViewToilets();
          window.location.reload();
        } else {
          Swal.fire(
            'Error!'
          );
        }
      }
    }catch(error){}
  }


}
